import A from './types';

const initialState = {
  paymentOrderInfo: {
    loading: false,
    error: false,
    data: {},
  },
  createOrderInfo: {
    loading: false,
    error: false,
    data: {},
  },
  orderPaymentInfo: {
    loading: false,
    error: false,
    data: {},
  },
  payInfo: {
    loading: false,
    error: false,
    data: {},
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.GET_DIRECT_ORDER_INFO: {
      if (action.pending) {
        return {
          ...state,
          paymentOrderInfo: {
            loading: true,
            error: false,
            data: {},
          },
        };
      }
      if (action.payload.message === 'success') {
        return {
          ...state,
          paymentOrderInfo: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        paymentOrderInfo: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
          data: {},
        },
      };
    }
    case A.CUSTOMER_SERVICE_CREATE_ORDER: {
      if (action.pending) {
        return {
          ...state,
          createOrderInfo: {
            loading: true,
            error: false,
            data: {},
          },
        };
      }
      if (action.payload.message === 'success') {
        return {
          ...state,
          createOrderInfo: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        createOrderInfo: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
          data: {},
        },
      };
    }
    case A.GET_DIRECT_ORDER_PAYMENT_INFO: {
      if (action.pending) {
        return {
          ...state,
          orderPaymentInfo: {
            loading: true,
            error: false,
            data: {},
          },
        };
      }
      if (action.payload.state_message && action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          orderPaymentInfo: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        orderPaymentInfo: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
          data: {},
        },
      };
    }
    case A.CREATE_PAY_ORDER: {
      if (action.pending) {
        return {
          ...state,
          payInfo: {
            loading: true,
            error: false,
            data: {},
          },
        };
      }
      if (action.payload.state_message && action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          payInfo: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        payInfo: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
          data: {},
        },
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/customerServicePaymentProcess/reducer.js